import { combineReducers } from 'redux';
import { createWidgetsReducer } from 'widgets/store/widgetsReducerFactory';
import { VenueAnalysisCapsuleState } from 'widgets/venueAnalysis/capsules/store/VenueAnalysisCapsuleState';
import { VenueAnalysisCapsuleActionPayload } from 'widgets/venueAnalysis/capsules/store/actions';
import { buildOrderFillsCapsuleConfigSlice } from './configslice';
import { OrderFillsCapsuleWidgetType } from '../types/OrderFillsCapsuleWidgetType';

const orderFillsCapsuleWidgetReducer = (
    widgetType: OrderFillsCapsuleWidgetType
) =>
    combineReducers<VenueAnalysisCapsuleState>({
        config: buildOrderFillsCapsuleConfigSlice(widgetType).reducer,
    });

export const orderFillsCapsuleWidgetsReducer = (
    widgetType: OrderFillsCapsuleWidgetType
) =>
    createWidgetsReducer<
        VenueAnalysisCapsuleState,
        VenueAnalysisCapsuleActionPayload
    >(widgetType, orderFillsCapsuleWidgetReducer(widgetType));
